'use client';

import { useEffect } from 'react';
import {
  KUKA_PLASHKI,
  LEGASI_SITE,
  PUTI_LEGASI,
  SROK_KUKI_SEKUND,
  staryjPosetitel,
} from '@/lib/ais-plashka';
import { KUKA_COOKIE, SROK_COOKIE_SEKUND } from '@/lib/ais-cookie';
import { cel, celIZhdat, razdel } from '@/lib/metrika-celi';

/**
 * Нажатия в плашке и полосе cookie, и страховка их скрытия (#212).
 *
 * Встроенные скрипты плашки и полосы только прячут их по куке до
 * отрисовки. Выполняются они лишь при загрузке страницы: если человек
 * пришёл на страницу без плашки (вход, регистрация) и оттуда перешёл на
 * витрину без перезагрузки, React вставит разметку, но скрипт не
 * запустит. Поэтому классы ставятся и здесь, после гидратации.
 *
 * Обработчик нажатий один на страницу (флаг `__aisKliki`), хотя
 * компонент стоит и в плашке, и в полосе: иначе одно нажатие ставило бы
 * куку дважды. До гидратации ссылки работают и так: ведут на серверные
 * ручки, которые ставят куку сами.
 */

declare global {
  interface Window {
    __aisKliki?: boolean;
  }
}

function estKuka(imya: string): boolean {
  return document.cookie.split('; ').includes(`${imya}=1`);
}

function postavit(imya: string, srok: number): void {
  document.cookie = `${imya}=1;path=/;max-age=${String(srok)};samesite=lax${
    location.protocol === 'https:' ? ';secure' : ''
  }`;
}

export function AisKukiStrahovka() {
  useEffect(() => {
    const html = document.documentElement;
    if (estKuka(KUKA_PLASHKI) || !staryjPosetitel(document.cookie))
      html.classList.add('ais-plashka-skryta');
    if (estKuka(KUKA_COOKIE)) html.classList.add('ais-cookie-prinyato');
    if (window.__aisKliki) return;
    window.__aisKliki = true;

    const legasi = new Set(PUTI_LEGASI);
    document.addEventListener('click', (e) => {
      const el = e.target instanceof Element ? e.target : null;
      const a = el?.closest('[data-ais-plashka] a, #ais-cookie [data-ponyatno]');
      if (!(a instanceof HTMLAnchorElement)) return;

      if (a.hasAttribute('data-prezhnyaya')) {
        const p = location.pathname;
        a.href = LEGASI_SITE + (p === '/' || legasi.has(p) ? p + location.search : '/');
        // Ушедший на прежнюю версию попадает на другой счётчик, и у нас
        // это выглядело бы отказом. Цель показывает, сколько таких (Seo,
        // 05.10.2026). Открытие в новой вкладке не перехватываем: страница
        // остаётся, цель успеет уйти и так.
        const params = { stranica: razdel(p) };
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
          cel('legacy_back', params);
          return;
        }
        e.preventDefault();
        const kuda = a.href;
        void celIZhdat('legacy_back', params).then(() => {
          location.assign(kuda);
        });
        return;
      }
      if (a.hasAttribute('data-zakryt')) {
        e.preventDefault();
        postavit(KUKA_PLASHKI, SROK_KUKI_SEKUND);
        html.classList.add('ais-plashka-skryta');
        return;
      }
      if (a.hasAttribute('data-ponyatno')) {
        e.preventDefault();
        postavit(KUKA_COOKIE, SROK_COOKIE_SEKUND);
        html.classList.add('ais-cookie-prinyato');
      }
    });
  }, []);

  return null;
}
